module.exports = __webpack_public_path__ + "assets/img/address-back.a97f7450.png";